/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** Monitor / desktop outline (18×18 Figma). Color via `currentColor`. */
const MonitorIcon = ({
  size = 18,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d="M3.75 3H14.25C15.0779 3 15.75 3.67213 15.75 4.5V11.25C15.75 12.0779 15.0779 12.75 14.25 12.75H3.75C2.92213 12.75 2.25 12.0779 2.25 11.25V4.5C2.25 3.67213 2.92213 3 3.75 3V3"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M6 15.75H12M9 12.75V15.75" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

MonitorIcon.propTypes = iconPropTypes;

export default MonitorIcon;
